import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILeaseEvent, ILeaseFullEvent } from '@api'
import { contractEventFragment } from '@api/fragments'
import { omit } from 'lodash'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createContractEvent: { contractEvent: ILeaseFullEvent }
}

const mutateHandler = handleFetchResult<IPayload, ILeaseFullEvent>({
  handler: (data) => data.createContractEvent.contractEvent,
  name: 'Contract Event',
})

export default function create(contractId: string, event: ILeaseEvent) {
  return client.gql
    .mutate({
      mutation: createMutation,
      variables: {
        input: {
          contractId,
          amount: event.amount.toString(),
          ...omit(event, 'id', 'createdBy', 'createdAt', 'files', 'amount', '__typename'),
        },
      },
    })
    .then(mutateHandler)
}

const createMutation = gql`
  mutation createContractEvent($input: CreateContractEventInput!) {
    createContractEvent(input: $input) {
      contractEvent {
        ...ContractEventFragment
      }
    }
  }
  ${contractEventFragment}
`
